import { FixedBanner, TextLink } from '@circlefin/components'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'

export interface WrongNetworkAlertProps {
  /**
   * Custom className.
   */
  className?: string

  /**
   * Desired blockchain name.
   */
  blockchain: string

  /**
   * Is connecting wallet.
   */
  isConnecting?: boolean

  /**
   * Switch network callback.
   */
  onSwitchNetwork?: () => void
}

export const WrongNetworkAlert: React.FC<WrongNetworkAlertProps> = ({
  className,
  blockchain,
  onSwitchNetwork,
}) => {
  const { t } = useTranslation('ace')

  return (
    <FixedBanner
      className={cn('flex', className)}
      data-testid="wrong-network-alert"
      multiline={false}
      status="error"
    >
      <FixedBanner.Title>{t('alert.wrongNetwork.title')}</FixedBanner.Title>
      <FixedBanner.Description>
        <p>{t('alert.wrongNetwork.description', { blockchain })}</p>
        <TextLink
          className="p-0 normal-case"
          onClick={onSwitchNetwork}
          size="sm"
          variant="primary"
        >
          {t('alert.wrongNetwork.cta')}
        </TextLink>
      </FixedBanner.Description>
    </FixedBanner>
  )
}
